<template>
    <RecommendedItem v-if="featuredContent.length > 0" :title="$t('LandingPage.recommended_items_featured_courses_and_learning_paths_title')">
        <CarouselCourses theme="dark" :courses="featuredContent" />
    </RecommendedItem>
</template>

<script>
    import { mapGetters } from 'vuex'
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import CarouselCourses from 'components/user/summary/carousel/CarouselCourses'
    import withLanguage from 'components/landingpage/recommended-items/mixins/with-language'

    export default {
        components: { CarouselCourses, RecommendedItem },
        computed: {
            ...mapGetters({
                featuredContent: 'Courses/getFeaturedContent'
            })
        },
        data () {
            return {
                storeUpdateContentAction: 'Courses/loadFeaturedContent'
            }
        },
        mixins: [withLanguage]
    }
</script>
